// ─────────────────────────────────────────────────────────────────────────────
// hooks/index.ts — Typed Redux hooks
//
// Always import useAppDispatch / useAppSelector from here instead of
// react-redux directly.  The typed versions provide full autocomplete and
// eliminate the need to cast RootState on every useSelector call.
// ─────────────────────────────────────────────────────────────────────────────

import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from '@/store';

/** Typed dispatch — knows about async thunks and correct action types */
export const useAppDispatch: () => AppDispatch = useDispatch;

/** Typed selector — no need to pass RootState manually */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
